export const DYNAMIC_PRICING_BASE = '/dynamic-pricing';

export const DYNAMIC_PRICING_TAB_SLUGS = [
  'dashboard',
  'recommendations',
  'rules',
  'events',
  'competitor',
  'simulate',
  'forecast',
  'config',
  'history',
];

export const DYNAMIC_PRICING_COMPETITOR_SUB_SLUGS = ['compare', 'rates', 'map'];

export const DYNAMIC_PRICING_HISTORY_SUB_SLUGS = ['publish-logs', 'recent'];

const TAB_SLUG_TO_INDEX = Object.fromEntries(
  DYNAMIC_PRICING_TAB_SLUGS.map((slug, index) => [slug, index]),
);

const COMPETITOR_SUB_SLUG_TO_INDEX = Object.fromEntries(
  DYNAMIC_PRICING_COMPETITOR_SUB_SLUGS.map((slug, index) => [slug, index]),
);

const HISTORY_SUB_SLUG_TO_INDEX = Object.fromEntries(
  DYNAMIC_PRICING_HISTORY_SUB_SLUGS.map((slug, index) => [slug, index]),
);

function normalizePathname(pathname) {
  const raw = (pathname || '').split('?')[0].split('#')[0];
  if (!raw || raw === DYNAMIC_PRICING_BASE) {
    return DYNAMIC_PRICING_BASE;
  }
  return raw.replace(/\/+$/, '');
}

export function parseDynamicPricingPath(pathname) {
  const normalized = normalizePathname(pathname);
  if (normalized === DYNAMIC_PRICING_BASE) {
    return {
      activeTab: 0,
      competitorSubTab: 0,
      historyLogsTab: 0,
      invalid: false,
    };
  }

  if (!normalized.startsWith(`${DYNAMIC_PRICING_BASE}/`)) {
    return {
      activeTab: 0,
      competitorSubTab: 0,
      historyLogsTab: 0,
      invalid: true,
    };
  }

  const rest = normalized.slice(`${DYNAMIC_PRICING_BASE}/`.length);
  const segments = rest.split('/').filter(Boolean);
  const mainSlug = segments[0] || 'dashboard';

  if (!Object.prototype.hasOwnProperty.call(TAB_SLUG_TO_INDEX, mainSlug)) {
    return {
      activeTab: 0,
      competitorSubTab: 0,
      historyLogsTab: 0,
      invalid: true,
    };
  }

  const activeTab = TAB_SLUG_TO_INDEX[mainSlug];
  let competitorSubTab = 0;
  let historyLogsTab = 0;

  if (mainSlug === 'competitor') {
    const subSlug = segments[1] || 'compare';
    if (segments[1] && !Object.prototype.hasOwnProperty.call(COMPETITOR_SUB_SLUG_TO_INDEX, subSlug)) {
      return { activeTab, competitorSubTab: 0, historyLogsTab: 0, invalid: true };
    }
    competitorSubTab = COMPETITOR_SUB_SLUG_TO_INDEX[subSlug] ?? 0;
  }

  if (mainSlug === 'history') {
    const subSlug = segments[1] || 'publish-logs';
    if (segments[1] && !Object.prototype.hasOwnProperty.call(HISTORY_SUB_SLUG_TO_INDEX, subSlug)) {
      return { activeTab, competitorSubTab: 0, historyLogsTab: 0, invalid: true };
    }
    historyLogsTab = HISTORY_SUB_SLUG_TO_INDEX[subSlug] ?? 0;
  }

  if (segments.length > (mainSlug === 'competitor' || mainSlug === 'history' ? 2 : 1)) {
    return { activeTab, competitorSubTab, historyLogsTab, invalid: true };
  }

  return {
    activeTab,
    competitorSubTab,
    historyLogsTab,
    invalid: false,
  };
}

export function buildDynamicPricingPath(activeTab, competitorSubTab = 0, historyLogsTab = 0) {
  const mainSlug = DYNAMIC_PRICING_TAB_SLUGS[activeTab] || 'dashboard';

  if (mainSlug === 'dashboard') {
    return `${DYNAMIC_PRICING_BASE}/`;
  }

  if (mainSlug === 'competitor') {
    const subSlug = DYNAMIC_PRICING_COMPETITOR_SUB_SLUGS[competitorSubTab] || 'compare';
    if (subSlug === 'compare') {
      return `${DYNAMIC_PRICING_BASE}/competitor/`;
    }
    return `${DYNAMIC_PRICING_BASE}/competitor/${subSlug}/`;
  }

  if (mainSlug === 'history') {
    const subSlug = DYNAMIC_PRICING_HISTORY_SUB_SLUGS[historyLogsTab] || 'publish-logs';
    if (subSlug === 'publish-logs') {
      return `${DYNAMIC_PRICING_BASE}/history/`;
    }
    return `${DYNAMIC_PRICING_BASE}/history/${subSlug}/`;
  }

  return `${DYNAMIC_PRICING_BASE}/${mainSlug}/`;
}
